// extracted by mini-css-extract-plugin
module.exports = {"pulser":"Sefirot_pulser__16jWR","ready":"Sefirot_ready__1Np1n","pulse":"Sefirot_pulse__3YqRO"};